import axios from 'axios'
import { enqueueSnackbar } from "notistack";
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { API } from "../../../helpers/constants";
import { handleAxiosErrors } from "../../../helpers/errorHandling";
import { useMuiGridServerSide } from "../../../hooks/muiGrid/useMuiGridServerSide";
import { PARAMETERS } from "../locales/namespaces";

const useCost = (UserId) => {
	const { t } = useTranslation(PARAMETERS)
	const [updateGridSource, setUpdateGridSource] = useState(false)
	const [loading, setLoading] = useState(false)
	const [updateCost, setUpdateCost] = useState(false)


	// const {isLoading, data, refreshGrid} = useMuiGridServerSide({
	// 	url: `${API}/en/fts/costs/index`,
	// 	initialPageSize: 50,
	// 	initialSortModel: [{name: 'id', direction: 'descending'}]
	// })
	const {
		isLoading,
		data,
		total,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange,
		refreshGrid
	} = useMuiGridServerSide({
		url: `fts/costs/index`,
		initialPageSize: 50,
		otherDataParams: {
			UserId: UserId,
		},
		initialSortModel: [{ name: 'id', direction: 'descending' }]
	})
	
	const store = (newRow) => {
		axios.post(`${API}/en/fts/cost/store`, { newRow }).then(res => {
			enqueueSnackbar(t('Cost created successfully!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
			refreshGrid()
			setUpdateCost(!updateCost)
		}).catch(error => {
			if (error?.response?.data?.message === "There are overlapping intervals.") {
				enqueueSnackbar(t('There is a record within this date range!'), {
					variant: 'error',
					autoHideDuration: 1700,
				})
			} else {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'warning',
					autoHideDuration: 3000,
				})
			}
		})
		refreshGrid()
	}
	const update = (newRow, oldRow) => {
		axios.post(`${API}/en/fts/cost/update`, { newRow }).then(response => {
			enqueueSnackbar(t('Cost updated successfully!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
			refreshGrid()
			setUpdateCost(!updateCost)
		}).catch(error => {
			if (error?.response?.data?.message === "There are overlapping intervals.") {
				// enqueueSnackbar(handleAxiosErrors(error, t('There is a record within this date range!'), {
				// 	variant: 'warning',
				// 	autoHideDuration: 3000,
				// }))
				enqueueSnackbar(t('There is a record within this date range!'), {
					variant: 'error',
					autoHideDuration: 1700,
				})
			} else {
				enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
					variant: 'warning',
					autoHideDuration: 3000,
				})
			}
			refreshGrid()
		})
	}
	const remove = (row) => {
		axios.post(`${API}/en/fts/cost/remove`, { id: row }).then(res => {
			enqueueSnackbar(t('Cost deleted successfully!'), {
				variant: 'success',
				autoHideDuration: 3000,
			})
			refreshGrid()
			setUpdateCost(!updateCost)
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'warning',
				autoHideDuration: 3000,
			})
		})
	}
	
	return {
		data,
		isLoading,
		refreshGrid,
		loading,
		store,
		remove,
		update,
		updateGridSource,
		total,
		page,
		pageSize,
		onPaginationModelChange,
		onSortModelChange,
		onFilterModelChange,
	}
}
export default useCost